const icon = require('vue-svgicon');
icon.register({
    'document': {
        width: 20,
        height: 20,
        viewBox: '0 0 20 20',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17.221 5.558v12.775a.555.555 0 01-.555.556H3.333a.555.555 0 01-.556-.556V1.667c0-.307.249-.556.556-.556h9.444v.002l4.443 4.443h.001v.001zM12.777 2.48v3.076h3.075L12.777 2.48zm0 4.188h3.333v10.554a.555.555 0 01-.555.556H4.444a.555.555 0 01-.556-.556V2.779c0-.308.25-.556.556-.556h7.222v4.445h1.111zm.556 7.776H6.666a.555.555 0 110-1.111h6.667a.556.556 0 010 1.111zm-6.667-3.333h6.667a.555.555 0 100-1.111H6.666a.555.555 0 100 1.111z" _fill="#000"/>`,
    },
});
